import React from 'react';

const VARIANTS = {
  primary:
    'bg-ink text-white hover:bg-ink-2 disabled:bg-mute disabled:cursor-not-allowed active:scale-[0.98]',
  secondary:
    'bg-transparent text-ink border border-line hover:border-ink disabled:text-mute disabled:border-line disabled:cursor-not-allowed',
  quiet:
    'bg-cream-2 text-ink hover:bg-line-2 disabled:text-mute disabled:cursor-not-allowed',
  danger:
    'bg-transparent text-accent-danger border border-line hover:border-accent-danger',
};

const SIZES = {
  md: 'px-5 py-3 text-[15px]',
  sm: 'px-4 py-2 text-[13px]',
  lg: 'px-6 py-4 text-base',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  trailingArrow = false,
  className = '',
  children,
  ...rest
}) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-full font-medium transition-colors duration-150 ${SIZES[size]} ${VARIANTS[variant]} ${className}`}
      {...rest}
    >
      <span>{children}</span>
      {trailingArrow && <span aria-hidden className="text-current">→</span>}
    </button>
  );
}
